import AdminLayout from "@/layouts/AdminLayout.vue"; // Import AdminLayout
import { isAdmin } from "./middlewares";
import { RouterView } from "vue-router"; // Import RouterView

// Admin Components
import AdminDashboardPage from "../views/Admin/DashboardPage.vue";
import ChinaUSAdminPage from "../views/Admin/ChinaUSAdminPage.vue";
import ChinaUSProjectDetailPage from "../views/Admin/ChinaUSProjectDetailPage.vue";
import LessonPlansFormPage from "../views/Admin/LessonPlans/FormPage.vue";
import LessonPlansListPage from "../views/Admin/LessonPlans/ListPage.vue";
import LessonPlansPreviewPage from "../views/Admin/LessonPlans/PreviewPage.vue";
import LessonPlansEditFormPage from "../views/Admin/LessonPlans/EditFormPage.vue";
import UsersFormPage from "../views/Admin/Users/FormPage.vue";
import UsersListPage from "../views/Admin/Users/ListPage.vue";
import CategoriesFormPage from "../views/Admin/Categories/FormPage.vue";
import CategoriesListPage from "../views/Admin/Categories/ListPage.vue";
import ysaDashboardPage from "../views/Admin/YSA/DashboardPage.vue";
import ysaSchoolListPage from "../views/Admin/YSA/SchoolListPage.vue";
import ysaStudentListPage from "../views/Admin/YSA/StudentListPage.vue";
import ysaTeacherListPage from "../views/Admin/YSA/teacherListPage.vue";
import AdminMasterclass from "@/views/Admin/YSA/AdminMasterclass.vue";
import AdminMasterclassEdit from "@/views/Admin/YSA/AdminMasterclassEdit.vue";
import AdminMasterclassForm from "@/views/Admin/YSA/AdminMasterclassForm.vue";
import MakerCartFormPage from "../views/Admin/MakerCart/FormPage.vue";
import MakerCartListPage from "../views/Admin/MakerCart/ListPage.vue";
import coachListPage from "../views/Admin/Coach/ListPage.vue";
import TermsFormPage from "../views/Admin/Term/FormPage.vue";
import TermsListPage from "../views/Admin/Term/ListPage.vue";
import ScormFormPage from "../views/Admin/ScormFiles/FormPage.vue";
import ScormListPage from "../views/Admin/ScormFiles/ListPage.vue";
import ChangeLogFormPage from "../views/Admin/ChangeLog/FormPage.vue";
import InviteTeacherFormPage from "../views/Admin/InviteTeacher/FormPage.vue";
import CommentListPage from "../views/Admin/Comments/ListPage.vue";
import FormSubmissionListPage from "../views/Admin/FormSubmission/ListPage.vue";
import PostLogListPage from "../views/Admin/PostLogs/ListPage.vue";
import RedeemListPage from "../views/Admin/Redeem/ListPage.vue";
import UserLogListPage from "../views/Admin/UserLogs/ListPage.vue";
import SFIAnalyticsPage from "../views/Admin/SFI/SFIAnalyticsPage.vue";
import ProfessionalDevelopmentListPage from "../views/Admin/ProfessionalDevelopment/ListPage.vue";
import ProfessionalDevelopmentFormPage from "../views/Admin/ProfessionalDevelopment/FormPage.vue";
import ProfessionalDevelopmentEditFormPage from "../views/Admin/ProfessionalDevelopment/EditFormPage.vue";
import LessonMaterialsListPage from "../views/Admin/LessonMaterials/ListPage.vue";
import LessonMaterialsFormPage from "../views/Admin/LessonMaterials/FormPage.vue";
import LessonMaterialsEditFormPage from "../views/Admin/LessonMaterials/EditFormPage.vue";
import LessonMaterialsPreviewPage from "../views/Admin/LessonMaterials/PreviewPage.vue";
import ProfessionalDevelopmentPreviewPage from "../views/Admin/ProfessionalDevelopment/PreviewPage.vue";
import MakercartAnalyticsPage from "../views/Admin/MakercartAnalyticsPage.vue";
import QuoteLogListPage from "../views/Admin/QuoteLog/ListPage.vue";
import TrainerAcademyModulesPage from "../views/Admin/TrainerAcademy/TrainerAcademyModulesPage.vue";

const adminRoutes = [
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true },
    beforeEnter: async () => {
      const allowed = await isAdmin();

      if (!allowed) {
        return { path: "/" };
      }
    },
    children: [
      {
        path: "dashboard",
        component: AdminDashboardPage,
        meta: { requiresAuth: true, title: "Dashboard Admin" },
      },
      {
        path: "china-us",
        component: RouterView,
        children: [
          {
            path: "",
            name: "ChinaUSAdminPage",
            component: ChinaUSAdminPage,
            meta: { requiresAuth: true, title: "China US Admin" },
          },
          {
            path: "projects/:id",
            name: "ChinaUSProjectDetailPage",
            component: ChinaUSProjectDetailPage,
            meta: { requiresAuth: true, title: "China US Project Detail" },
          },
        ],
      },
      {
        path: "lesson-plans",
        component: RouterView,
        children: [
          {
            path: "",
            name: "LessonPlansListPage",
            component: LessonPlansListPage,
            meta: { requiresAuth: true, title: "Lesson Plan" },
          },
          {
            path: "form",
            name: "LessonPlansFormPage",
            component: LessonPlansFormPage,
            meta: { requiresAuth: true, title: "Form Lesson Plan" },
          },
          {
            path: "form/:id",
            name: "LessonPlansEditPage",
            component: LessonPlansEditFormPage,
            meta: { requiresAuth: true, title: "Edit Lesson Plan" },
          },
          {
            path: "preview/:id",
            name: "LessonPlansPreviewPage",
            component: LessonPlansPreviewPage,
            meta: { requiresAuth: true, title: "Preview Lesson Plan" },
          },
        ],
      },
      {
        path: "professional-development",
        component: RouterView,
        children: [
          {
            path: "",
            name: "ProfessionalDevelopmentListPage",
            component: ProfessionalDevelopmentListPage,
            meta: { requiresAuth: true, title: "Professional Development" },
          },
          {
            path: "form",
            name: "ProfessionalDevelopmentFormPage",
            component: ProfessionalDevelopmentFormPage,
            meta: {
              requiresAuth: true,
              title: "Form Professional Development",
            },
          },
          {
            path: "form/:id",
            name: "ProfessionalDevelopmentEditPage",
            component: ProfessionalDevelopmentEditFormPage,
            meta: {
              requiresAuth: true,
              title: "Edit Professional Development",
            },
          },
          {
            path: "preview/:id",
            name: "ProfessionalDevelopmentPreviewPage",
            component: ProfessionalDevelopmentPreviewPage,
            meta: {
              requiresAuth: true,
              title: "Preview Professional Development",
            },
          },
        ],
      },
      {
        path: "lesson-materials",
        component: RouterView,
        children: [
          {
            path: "",
            name: "LessonMaterialsListPage",
            component: LessonMaterialsListPage,
            meta: { requiresAuth: true, title: "Lesson Materials" },
          },
          {
            path: "form",
            name: "LessonMaterialsFormPage",
            component: LessonMaterialsFormPage,
            meta: { requiresAuth: true, title: "Form Lesson Materials" },
          },
          {
            path: "form/:id",
            name: "LessonMaterialsEditPage",
            component: LessonMaterialsEditFormPage,
            meta: { requiresAuth: true, title: "Edit Lesson Materials" },
          },
          {
            path: "preview/:id",
            name: "LessonMaterialsPreviewPage",
            component: LessonMaterialsPreviewPage,
            meta: { requiresAuth: true, title: "Preview Lesson Materials" },
          },
        ],
      },
      {
        path: "quote-log",
        component: QuoteLogListPage,
        meta: { requiresAuth: true, title: "Quote Log" },
      },
      {
        path: "makercart-analytics",
        component: MakercartAnalyticsPage,
        meta: { requiresAuth: true, title: "Makercart Analytics" },
      },
      {
        path: "users",
        component: RouterView,
        children: [
          {
            path: "",
            name: "UsersListPage",
            component: UsersListPage,
            meta: { requiresAuth: true, title: "Users" },
          },
          {
            path: "form",
            name: "UsersFormPage",
            component: UsersFormPage,
            meta: { requiresAuth: true, title: "Form Users" },
          },
          {
            path: "form/:id",
            name: "UsersEditPage",
            component: UsersFormPage,
            meta: { requiresAuth: true, title: "Edit Users" },
          },
        ],
      },
      {
        path: "categories",
        component: RouterView,
        children: [
          {
            path: "",
            name: "CategoriesListPage",
            component: CategoriesListPage,
            meta: { requiresAuth: true, title: "Category" },
          },
          {
            path: "form",
            name: "CategoriesFormPage",
            component: CategoriesFormPage,
            meta: { requiresAuth: true, title: "Form Category" },
          },
          {
            path: "form/:id",
            name: "CategoriesEditPage",
            component: CategoriesFormPage,
            meta: { requiresAuth: true, title: "Edit Category" },
          },
        ],
      },
      {
        path: "terms",
        component: RouterView,
        children: [
          {
            path: ":id",
            name: "TermsListPage",
            component: TermsListPage,
            meta: { requiresAuth: true, title: "Term" },
          },
          {
            path: "form/:submissionId",
            name: "TermsFormPage",
            component: TermsFormPage,
            meta: { requiresAuth: true, title: "Form Term" },
          },
          {
            path: "form/:submissionId/:id",
            name: "TermsEditPage",
            component: TermsFormPage,
            meta: { requiresAuth: true, title: "Edit Term" },
          },
        ],
      },
      {
        path: "redeem",
        component: RouterView,
        children: [
          {
            path: "",
            name: "redeemListPage",
            component: RedeemListPage,
            meta: { requiresAuth: true, title: "Redeem" },
          },
        ],
      },
      {
        path: "comment",
        component: RouterView,
        children: [
          {
            path: "",
            name: "commentListPage",
            component: CommentListPage,
            meta: { requiresAuth: true, title: "Comment" },
          },
        ],
      },
      {
        path: "userlog",
        component: RouterView,
        children: [
          {
            path: "",
            name: "userLogListPage",
            component: UserLogListPage,
            meta: { requiresAuth: true, title: "User Log" },
          },
        ],
      },
      {
        path: "contentLog",
        component: RouterView,
        children: [
          {
            path: "",
            name: "contentLogListPage",
            component: PostLogListPage,
            meta: { requiresAuth: true, title: "Content Log" },
          },
        ],
      },
      {
        path: "formSubmission",
        component: RouterView,
        children: [
          {
            path: "",
            name: "formSubmissionListPage",
            component: FormSubmissionListPage,
            meta: { requiresAuth: true, title: "Form Submission" },
          },
        ],
      },
      {
        path: "ysa",
        component: RouterView,
        children: [
          // ysaDashboardPage
          {
            path: "dashboard",
            name: "ysaDashboardPage",
            component: ysaDashboardPage,
            meta: { requiresAuth: true, title: "Dashboard Page" },
          },
          {
            path: "ysaTeacherListPage",
            name: "ysaTeacherListPage",
            component: ysaTeacherListPage,
            meta: { requiresAuth: true, title: "Teacher List Page" },
          },
          {
            path: "ysaStudentListPage",
            name: "ysaStudentListPage",
            component: ysaStudentListPage,
            meta: { requiresAuth: true, title: "Student List Page" },
          }, //SchoolListPage.vue
          {
            path: "ysaSchoolListPage",
            name: "ysaSchoolListPage",
            component: ysaSchoolListPage,
            meta: { requiresAuth: true, title: "School List Page" },
          },
          {
            path: "masterclass",
            name: "ysaMasterclass",
            component: AdminMasterclass,
            meta: { requiresAuth: true, title: "Masterclass" },
          },
          {
            path: "masterclass/form",
            name: "ysaMasterclassForm",
            component: AdminMasterclassForm,
            meta: { requiresAuth: true, title: "Masterclass Form" },
          },
          {
            path: "masterclass/:id/edit",
            name: "ysaMasterclassEdit",
            component: AdminMasterclassEdit,
            meta: { requiresAuth: true, title: "Masterclass Edit" },
          },
        ],
      },
      {
        path: "coach",
        component: RouterView,
        children: [
          {
            path: "",
            name: "coachListPage",
            component: coachListPage,
            meta: { requiresAuth: true, title: "Coach Page" },
          },
        ],
      },
      {
        path: "scorm",
        component: RouterView,
        children: [
          {
            path: "",
            name: "ScormListPage",
            component: ScormListPage,
            meta: { requiresAuth: true, title: "Category" },
          },
          {
            path: "form",
            name: "ScormCreatePage",
            component: ScormFormPage,
            meta: { requiresAuth: true, title: "Form Category" },
          },
          {
            path: "form/:id",
            name: "ScormEditPage",
            component: ScormFormPage,
            meta: { requiresAuth: true, title: "Edit Category" },
          },
        ],
      },
      {
        path: "trainer-academy",
        component: RouterView,
        children: [
          {
            path: "",
            name: "TrainerAcademyModulesPage",
            component: TrainerAcademyModulesPage,
            meta: { requiresAuth: true, title: "Trainer Academy Modules" },
          },
        ],
      },
      {
        path: "change-log",
        component: RouterView,
        children: [
          {
            path: "",
            name: "ChangeLogFormPage",
            component: ChangeLogFormPage,
            meta: { requiresAuth: true, title: "Form Change Log" },
          },
        ],
      },
      {
        path: "invite-teacher",
        component: RouterView,
        children: [
          {
            path: "",
            name: "InviteTeacherFormPage",
            component: InviteTeacherFormPage,
            meta: { requiresAuth: true, title: "Form Invite Teacher" },
          },
        ],
      },
      {
        path: "maker-cart",
        component: RouterView,
        children: [
          {
            path: "",
            name: "MakerCartListPage",
            component: MakerCartListPage,
            meta: { requiresAuth: true, title: "Stem Order Page" },
          },
          {
            path: "details/:id",
            name: "MakerCartFormPage",
            component: MakerCartFormPage,
            meta: { requiresAuth: true, title: "Stem Order Details Page" },
          },
        ],
      },
      {
        path: "sfi-analytics",
        component: RouterView, // Gunakan RouterView di sini
        children: [
          {
            path: "",
            name: "SFIAnalyticsPage",
            component: SFIAnalyticsPage,
            meta: { requiresAuth: true, title: "SFI Analytics Page" },
          },
        ],
      },
    ],
  },
];

export default adminRoutes;
